import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { focusTrap } from './directives/focusTrap'
import { registerServiceWorker } from './services/pwaService'
import './styles.css'

const app = createApp(App)
app.directive('focus-trap', focusTrap)
app.use(router)
app.mount('#app')

registerServiceWorker()
